import React from "react";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import PrivateRoute from "../utilities/PrivateRoute";
// Pages
import AddClients from "../components/Clients/AddClients";
import AddServiceRequest from "../components/ServiceRequests/AddServiceRequest";
import ServiceRequestDashboard from "../components/ServiceRequests/ServiceRequestDashboard";
import ServiceRequestList from "../components/ServiceRequests/ServiceRequestList";
import ClientList from "../components/Clients/ClientList";
import BillableHours from "../components/General/BillableHours";
import EditClient from "../components/Clients/EditClient";
import EditServiceRequest from "../components/ServiceRequests/EditServiceRequest";
import keycloak from "../Keycloak";
import Unauthorized from "../components/General/Unauthorized";
import MyCV from "../components/CV/MyCV";
import StaffMemberListView from "../components/CV/StaffMemberListView";
import ConsultantList from "../components/Consultant/ConsultantList";
import ExternalCV from "../components/CV/ExternalCV";
import AddCV from "../components/HR/AddCV";
import CVList from "../components/HR/CVList";
import OrgCV from "../components/HR/OrgCV";
import Candidates from "../components/HR/Candidate/Candidates";
import ApplicationScoring from "../components/HR/ApplicationScoring";
import Home from "../pages/home";
import CandidateView from "../components/HR/Candidate/CandidateView";
import JobsList from "../components/Jobs/JobsList"
import JobsAdd from "../components/Jobs/JobAdd"
import JobsEdit from "../components/Jobs/JobEdit"
import JobView from "../components/Jobs/JobView";
import JobOpportunities from "../components/Jobs/JobOpportunities";
import JobListing from "../components/Jobs/JobListing";
import JobDetails from "../components/Jobs/JobDetails";
import TrailExpired from "../components/General/TrailExpired/TrailExpired";



export const AppRouter = () => {
    /*
    * Available Roles
    *
    * system_admin
    * account_manager
    * delivery_manager
    * internal_user
    * client_admin
    * client_user
    * client_recruiter
    * hr_admin
    * expired_trial
    */

    const isHrAdmin = keycloak && (keycloak.hasResourceRole("hr_admin") || keycloak.hasResourceRole("client_recruiter"));
    const hasExpired = keycloak && (keycloak.hasResourceRole("expired_trial"));

    return (
        <>
            <BrowserRouter>
                {hasExpired && <Navigate to="/expired" replace />}

                <Routes>
                    <Route exact path="/" element={
                        <PrivateRoute>
                            {isHrAdmin ? (
                                <Home/>
                            ) : (
                                <Navigate to="/ServiceRequestList"/>
                            )}
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/ClientPage" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager")) ?
                                <AddClients/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/EditClientPage" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager")) ?
                                <EditClient/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/ServiceRequest" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager") ||
                                keycloak.hasResourceRole("delivery_manager")) ?
                                <AddServiceRequest/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/EditServiceRequest" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager") ||
                                keycloak.hasResourceRole("delivery_manager")) ?
                                <EditServiceRequest/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/ServiceRequestDashboard" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("client_admin") ||
                                keycloak.hasResourceRole("client_user") ||
                                keycloak.hasResourceRole("client_recruiter")) ?
                                <ServiceRequestDashboard/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/ProjectDashboard" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("account_manager") ||
                                keycloak.hasResourceRole("delivery_manager")) ?
                                <BillableHours/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/ServiceRequestList" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("client_admin") ||
                                keycloak.hasResourceRole("client_user")) ?
                                <ServiceRequestList/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path="/ClientList" element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("client_admin") ||
                                keycloak.hasResourceRole("client_recruiter")) ?
                                <ClientList/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path={"/StaffMemberListView"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("account_manager") ||
                                keycloak.hasResourceRole("hr_admin")) ?
                                <StaffMemberListView/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path={"/MyCV"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("internal_user") ||
                                keycloak.hasResourceRole("hr_admin")) ?
                                <MyCV/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />
                    <Route exact path={"/ConsultantList"} element={
                        <PrivateRoute>
                            {keycloak && keycloak.hasResourceRole("hr_admin") ?
                                <ConsultantList/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />

                    <Route exact path={"/ExternalCV"} element={
                        // <PublicLayout>
                            <ExternalCV/>
                        // </PublicLayout>
                    }
                    />

                    <Route exact path={"/CVList"} data-testid={"CVList"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("account_manager")) ?
                                <CVList/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />
                    <Route exact path={"/Candidates"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("client_recruiter")) ?
                                <Candidates/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />
                    <Route exact path={"/AddCV"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("hr_admin")) ?
                                <AddCV/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />
                    <Route exact path={"/OrgCV"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("hr_admin")) ?
                                <OrgCV/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }
                    />
                    <Route exact path={"/ApplicationScoring"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("client_recruiter")) ?
                                <ApplicationScoring/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }/>

                    <Route exact path={"/CandidateView"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("client_recruiter")) ?
                                <CandidateView/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }/>

                    <Route exact path={"/JobsList"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("client_recruiter")
                                ) ?
                                <JobsList/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }/>
                    <Route exact path={"/JobsAdd"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("hr_admin") ||
                                keycloak.hasResourceRole("client_recruiter"))
                                ?
                                <JobsAdd/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }/>
                    <Route exact path={"/JobsEdit"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("client_recruiter") ||
                                keycloak.hasResourceRole("hr_admin")) ?
                                <JobsEdit/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }/>
                    <Route exact path={"/JobView"} element={
                        <PrivateRoute>
                            {keycloak && (keycloak.hasResourceRole("system_admin") ||
                                keycloak.hasResourceRole("delivery_manager") ||
                                keycloak.hasResourceRole("client_recruiter") ||
                                keycloak.hasResourceRole("hr_admin")) ?
                                <JobView/>
                                :
                                <Unauthorized/>
                            }
                        </PrivateRoute>
                    }/>

                    <Route exact path={"/JobOpportunities"} element={
                        <JobOpportunities/>
                    }/>

                    <Route exact path={"/JobListing"} element={
                        <JobListing/>
                    }/>

                    <Route exact path={"/JobDetails"} element={
                        <JobDetails/>
                    }/>

                    <Route exact path="/expired" element={
                        <PrivateRoute>
                            <TrailExpired />
                        </PrivateRoute>
                    }
                    />

                </Routes>
            </BrowserRouter>
        </>
    );
};
